import { Box, Button, Heading, Text, VStack, Image, useToast, useDisclosure, Skeleton, Progress, useBreakpointValue } from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import { usePublishedItems } from '../../../hooks/useCourse';
import { useMutation } from 'react-query';
import { startAssessment } from '../../../apis/V2/assessment';
import { useNavigate } from 'react-router-dom';
import { AxiosError } from 'axios';
import { UIErrorResponse } from '../../../../../../packages/types/src/error';
import EliteProgramDrawer from '../Dashboard/EliteProgramDrawer';
import { useAssessmentSubmission } from '../../../hooks/V2/useAssessmentSumbission';
import ModalTemplateV2 from '../../common/ModalTemplateV2';
import { useAssessmentToken } from '../../../context/AssessmentTokenContext';
import { set } from 'mongoose';
import { useDomainConfig } from '../../../hooks/useDomainConfig';
import { useOriganisation } from '../../../hooks/useOrganisation';
import ForBetterExpModal from '../../common/V2/ForBetterExpModal';
import CountdownTimer from '../../common/CountdownTimer';
import { useUser, useUserProfile } from '../../../hooks/useUser';
import dayjs from 'dayjs';
import { sendTrackingEvent } from '../../../utils/gtm';

interface Props {
	setAssessmentStatus: (status: string) => void;
	selectedCourse: string;
	showWaitingModal: boolean;
	setShowWaitingModal: (show: boolean) => void;
}

export const MAX_ATTEMPTS = 20; // Maximum number of attempts
export const POLL_INTERVAL = 15000; // Polling interval in milliseconds (10 seconds)
const KnowYourLevelCard = ({ showWaitingModal, setShowWaitingModal, setAssessmentStatus, selectedCourse }: Props) => {
	const isMobile = useBreakpointValue({ base: true, md: false });
	const { data: publishedItems, refetch: refetchPublishedItems } = usePublishedItems(selectedCourse);
	const [assessmentPublishedItem, setAssessmentPublishedItem] = React.useState<any>();
	useEffect(() => {
		// filter first published item of type Roadmap
		if (!publishedItems) return;
		const assessment = publishedItems.find(item => item.entityType === 'Assessment');
		// @ts-ignore
		setAssessmentPublishedItem(assessment);
		console.log('assessment----', assessment);
	}, [publishedItems]);

	const [showTestWaitingModal, setShowTestWaitingModal] = useState(false);
	const {
		data: userAssessment,
		status,
		refetch: refetchUserAssessment,
		isLoading: loadingUserAssessment,
	} = useAssessmentSubmission(assessmentPublishedItem?._id || '');
	useEffect(() => {
		if (selectedCourse) {
			refetchPublishedItems();
		}
	}, [selectedCourse, refetchPublishedItems]);
	const navigate = useNavigate();

	useEffect(() => {
		if (!assessmentPublishedItem) return;
		refetchUserAssessment();
	}, [assessmentPublishedItem?._id, refetchUserAssessment]);

	useEffect(() => {
		console.log('userAssessment+++:', userAssessment);
		if (!userAssessment) return;

		setAssessmentStatus(userAssessment?.assessmentStatus);
	}, [userAssessment?.assessmentStatus]);

	const toast = useToast();
	const [showCongratsModal, setShowCongratsModal] = useState(false);
	const [showDeviceChangeModal, setShowDeviceChangeModal] = useState(false);
	const onCongratsModalClose = () => {
		localStorage.setItem(`showCongratsModal-${assessmentPublishedItem?._id}`, 'true');
		setShowCongratsModal(false);
	};

	useEffect(() => {
		// check if user has already seen the modal
		const showCongratsModal = localStorage.getItem(`showCongratsModal-${assessmentPublishedItem?._id}`);
		if (showCongratsModal === 'true') {
			return;
		}
		if (userAssessment?.assessmentStatus === 'GRADED') {
			setShowCongratsModal(true);
		}
	}, [userAssessment?.assessmentStatus, assessmentPublishedItem?._id]);
	const { setAssessmentToken, setRedirectionPath } = useAssessmentToken();
	const { mutate: startAssessmentMutate, isLoading: startAssessmentLoading } = useMutation(startAssessment, {
		onSuccess: response => {
			console.log('response:', response);
			setAssessmentToken(response.data.userAssessment.token);
			setRedirectionPath(window.location.pathname + window.location.search);
			setShowTestWaitingModal(false);
			// redirect to assessment page
			navigate(`/dashboard/published-item/${assessmentPublishedItem._id}/assessment/start`);
		},
		onError: (error: AxiosError<UIErrorResponse>) => {
			console.log('error:', error);
			toast({
				title: 'Error',
				description: error?.response?.data?.message || 'Unable to start assessment, please try again!',
				status: 'error',
				duration: 2000,
				isClosable: true,
				position: 'top',
			});
		},
	});

	const { isOpen: isEliteProgramDrawerOpen, onOpen: onEliteProgramDrawerOpen, onClose: onEliteProgramDrawerClose } = useDisclosure();

	const [pollInterval, setPollInterval] = useState<NodeJS.Timeout | null>(null); // State to store the interval reference
	const [attempts, setAttempts] = useState(0);
	const [startTimerEnded, setStartTimerEnded] = React.useState(false);
	const [endTimerEnded, setEndTimerEnded] = React.useState(false);
	useEffect(() => {
		if (!userAssessment) return;
		// Polling mechanism using setInterval
		const intervalId = setInterval(() => {
			// @ts-ignore
			setAttempts(prevAttempts => prevAttempts + 1);
			refetchUserAssessment(); // Manually trigger a refetch after each polling interval
		}, POLL_INTERVAL);

		setPollInterval(intervalId); // Store the interval reference in state

		// Clear interval when component unmounts or when desired result is obtained
		return () => {
			clearInterval(intervalId);
		};
	}, [refetchUserAssessment, userAssessment]);

	useEffect(() => {
		if (attempts > MAX_ATTEMPTS) {
			if (pollInterval) {
				clearInterval(pollInterval);
			}
			return;
		}

		if (attempts < MAX_ATTEMPTS && status === 'success') {
			// Check if the desired result is obtained, and if so, stop polling
			if (userAssessment && userAssessment.assessmentStatus === 'GRADED') {
				if (pollInterval) {
					clearInterval(pollInterval);
				}
			}
		}
	}, [attempts, userAssessment, status, pollInterval]);

	// ------------START dummy timer logic: TODO: NEED TO MAKE IT RESUSABLE

	const duration = 180;
	const [seconds, setSeconds] = useState(duration);
	useEffect(() => {
		// If the time is up, show a toast notification and clear the interval
		if (seconds === 0) {
			return;
		}

		// Set an interval to update the timer
		const interval = setInterval(() => {
			setSeconds(prevSeconds => prevSeconds - 1);
		}, 1000);

		// Clear interval on component unmount
		return () => clearInterval(interval);
	}, [seconds, toast]);

	const minutes = Math.floor(seconds / 60);
	const remainingSeconds = seconds % 60;

	// Convert minutes and seconds to strings and pad with 0 if necessary
	const formattedMinutes = minutes.toString().padStart(2, '0');
	const formattedSeconds = remainingSeconds.toString().padStart(2, '0');
	const percent = (seconds / duration) * 100;
	// ------------END dummy timer logic: TODO: NEED TO MAKE IT RESUSABLE

	// ---------------START timer logic for start test waiting
	const [progress, setProgress] = useState(0);
	const [time, setTime] = useState(60 * 1000);
	// Convert time from milliseconds to MM:SS format
	const minutes2 = Math.floor(time / 1000 / 60);
	const seconds2 = Math.floor((time / 1000) % 60);
	const timeFormat = `${minutes2.toString().padStart(2, '0')}:${seconds2.toString().padStart(2, '0')}`;

	useEffect(() => {
		// Calculate the interval required for a 30-second progress bar
		// Here, '30' represents 30 seconds, and '1000' converts seconds to milliseconds.
		const intervalTime = (60 * 1000) / 100; // Divided by 100 because the progress bar has 100 steps
		const interval = setInterval(() => {
			setProgress(oldProgress => {
				// Determine the next progress value
				const newProgress = oldProgress + 1;

				// Update the remaining time
				setTime(oldTime => {
					const newTime = oldTime - intervalTime;
					return newTime;
				});

				// If progress is 100, clear the interval
				if (newProgress === 100) {
					clearInterval(interval);
				}

				return newProgress;
			});
		}, intervalTime);

		// Cleanup the interval on component unmount
		return () => clearInterval(interval);
	}, []); // The empty dependency array ensures the effect runs once on mount

	// ---------------END timer logic for start test waiting
	const { data: domainConfig } = useDomainConfig({ uiHost: window.location.host });
	const { data: organisation } = useOriganisation(domainConfig?.organisation);
	const { data: user } = useUser();
	const { data: userProfile } = useUserProfile();
	// console.log(`User profile --- ${userProfile.isEliteEligible}`);

	return (
		<>
			{userAssessment?.assessmentStatus === 'GRADED' ? (
				<Box
					boxShadow={'0px 1px 2px 0px rgba(0, 0, 0, 0.06), 0px 1px 3px 0px rgba(0, 0, 0, 0.10)'}
					position={'relative'}
					border="1px solid #CFEEDF"
					p="16px"
					pb={
						// @ts-ignore
						userProfile.isEliteEligible === 'notEligible' || user?.isOldData ? '16px' : '0px'
					}
					borderRadius={'16px'}
					bgColor={'#EEFFF7'}
				>
					<Box gap="6px" display={'grid'}>
						<Box display={'flex'} justifyContent={'start'} gap="10px" alignItems={'center'}>
							<Box display={'flex'} alignItems={'center'} gap="8px">
								<Image boxSize={'18px'} src={'/images/icons/know-your-result-1.svg'} />
								<Text textStyle={'body2'}>Test Result</Text>
							</Box>
							<Box>
								<Text textStyle={'body1-md'} color="#6E71CC">
									{
										// @ts-ignore
										// remove decimal points
										userAssessment?.percentile || 'NA'
									}
									<Text as="sup">th</Text> Percentile
								</Text>
							</Box>
						</Box>
						<Box display={'flex'} alignItems={'center'} mt="10px" gap="8px" justifyContent={{ base: 'center', md: 'start' }}>
							<Text textStyle={'caption'} px="10px" py="6px" color="#0A0103" border="1px solid #F3F2F2" bgColor={'#F3F2F2'} borderRadius={'8px'}>
								College Rank{' '}
								<Text textStyle={'caption'} as="span" color="#7261DF">
									:{' '}
									{
										// @ts-ignore
										userAssessment?.collegeRank || 'NA'
									}
								</Text>
							</Text>
							<Text textStyle={'caption'} px="10px" py="6px" color="#0A0103" border="1px solid #F3F2F2" bgColor={'#F3F2F2'} borderRadius={'8px'}>
								All India Rank{' '}
								<Text textStyle={'caption'} as="span" color="#7261DF">
									:{' '}
									{
										// @ts-ignore
										userAssessment?.overAllRank || 'NA'
									}
								</Text>
							</Text>
							{/* <Box display={'flex'} alignItems={'center'} gap="8px">
								<Image boxSize={'18px'} src={'images/icons/know-your-result-2.svg'} />
								<Text textStyle={'body2'}>Badges collected</Text>
							</Box> */}
							{/* <Box>
								<Text textStyle={'body1-md'} color="#6E71CC">
									0
								</Text>
							</Box> */}
						</Box>
					</Box>
					{
						// @ts-ignore
						(userProfile && userProfile?.isEliteEligible === 'notEligible') || (user && user.isOldData) ? null : (
							<Box
								mt="12px"
								display={'grid'}
								// gridTemplateColumns={'repeat(2,1fr)'}
								gap="10px"
								px="16px"
								py="8px"
								borderBottomLeftRadius={'16px'}
								borderBottomRightRadius={'16px'}
								bgColor={'#FFF3CC'}
								mx="-16px"
							>
								<Box display={'flex'} gap="6px">
									<Image mt="-16px" src="https://masai-website-images.s3.ap-south-1.amazonaws.com/_c5b6919192.svg" />
									<Box w="100%">
										{userProfile && userProfile?.isEliteEligible === 'eligible' ? (
											<Text textStyle={'caption'}>You are eligible for the</Text>
										) : (
											<Text textStyle={'caption'}>Results awaiting for</Text>
										)}

										<Box display={'flex'} gap="6px">
											<Text textStyle={'body2-md'} color="#F47C32">
												Prepleaf Elite Program
											</Text>
											<Text
												cursor="pointer"
												onClick={() => {
													onEliteProgramDrawerOpen();
												}}
												textStyle={'body2-md'}
												textDecoration={'underline'}
												color="#4358F6"
											>
												Know more.
											</Text>
										</Box>
									</Box>
								</Box>
							</Box>
						)
					}
				</Box>
			) : (
				<Skeleton rounded="16px" isLoaded={!startAssessmentLoading && !loadingUserAssessment}>
					<Box
						boxShadow={'0px 1px 2px 0px rgba(0, 0, 0, 0.06), 0px 1px 3px 0px rgba(0, 0, 0, 0.10)'}
						position={'relative'}
						border="1px solid #6FCD9E"
						p="16px"
						borderRadius={'16px'}
						bgColor={'#EEFFF7'}
					>
						<Image top="0" right="0" position={'absolute'} src="/images/icons/know-your-level.svg" />
						<Heading as="h6" color="#6FCD9E">
							Know Your Level
						</Heading>
						<Text mt="6px" color={'#544D4F'}>
							Discover where you stand to <br /> unlock job opportunities.
						</Text>
						{/* @ts-ignore */}
						{!organisation?.testStartDate || !organisation?.testEndDate || dayjs().isAfter(organisation?.testEndDate) ? (
							<></>
						) : (
							//  @ts-ignore
							dayjs().isBefore(organisation?.testEndDate) && (
								<>
									{dayjs().isAfter(organisation?.testStartDate) ? (
										// @ts-ignore
										<CountdownTimer type="end" setTimerEnd={setEndTimerEnded} date={organisation?.testEndDate} />
									) : (
										dayjs().isBefore(organisation?.testStartDate) && (
											// @ts-ignore
											<CountdownTimer type="start" setTimerEnd={setStartTimerEnded} date={organisation?.testStartDate} />
										)
									)}
								</>
							)
						)}
						<Button
							isLoading={startAssessmentLoading || loadingUserAssessment}
							onClick={() => {
								if (isMobile) {
									setShowDeviceChangeModal(true);
								} else {
									setShowTestWaitingModal(true);
									if (assessmentPublishedItem) {
										startAssessmentMutate({
											// @ts-ignore
											publishedItemId: assessmentPublishedItem?._id,
										});
									}
								}
								sendTrackingEvent({
									event: 'cnd_kyl_continue',
									eventLabel: window.location.href,
								});
							}}
							mt="16px"
							bgColor={'#4358F6'}
							variant={'primary'}
							isDisabled={user?.email?.includes('masaischool.com') ? false : !dayjs().isAfter(organisation?.testStartDate)}
						>
							{userAssessment?.assessmentStatus === 'PENDING' || userAssessment?.assessmentStatus === 'STARTED' ? 'Continue Test' : ' Start Test'}
						</Button>
					</Box>
				</Skeleton>
			)}
			<ForBetterExpModal
				isOpen={showDeviceChangeModal}
				onClose={() => {
					setShowDeviceChangeModal(false);
				}}
				onContinue={() => {
					setShowTestWaitingModal(true);
					if (assessmentPublishedItem) {
						startAssessmentMutate({
							// @ts-ignore
							publishedItemId: assessmentPublishedItem?._id,
						});
					}
				}}
			/>
			<EliteProgramDrawer
				isEligibleforEliteProgram={userProfile?.isEliteEligible}
				isOpen={isEliteProgramDrawerOpen}
				onClose={onEliteProgramDrawerClose}
				onOpen={onEliteProgramDrawerOpen}
			/>
			<ModalTemplateV2
				closeOnOverlayClick={true}
				isOpen={showCongratsModal}
				onClose={onCongratsModalClose}
				showConfetti={true}
				// hideIconWithConfetti={true}
				autoCloseInSeconds={30}
				extra={
					<Box>
						{/* <Image w={{ base: '260px', md: '348px' }} h={{ base: '226px', md: '302px' }} mx="auto" src="/images/giff/waiting-gif.gif"></Image> */}
						<Heading as="h4" maxW="472px" color="#E5E5E5">
							Congratulations!
						</Heading>

						<Text mt="8px" maxW="472px" color="#E5E5E5" textStyle={{ base: 'h6', md: 'h2' }}>
							You stand amongst{' '}
							<Text color="#FFDB66" as="span">
								{
									// @ts-ignore
									// remove decimal points
									userAssessment?.percentile || 'NA'
								}{' '}
								percentile
							</Text>{' '}
							and unlocked roadmap to your dream career!
						</Text>
						<Button onClick={onCongratsModalClose} variant={'primary'} bgColor={'#4358F6'} mt="24px">
							Continue
						</Button>
					</Box>
				}
			/>
			<ModalTemplateV2
				closeOnOverlayClick={false}
				isOpen={showWaitingModal}
				onClose={() => {
					setShowWaitingModal(false);
				}}
				showConfetti={false}
				hideIconWithConfetti={true}
				waiting={true}
				// autoCloseInSeconds={30}
				extra={
					<Box>
						{/* <Image w={{ base: '260px', md: '348px' }} h={{ base: '226px', md: '302px' }} mx="auto" src="/images/giff/waiting-gif.gif"></Image> */}
						<Heading as="h4" maxW="472px" color="#E5E5E5">
							Thank you for attempting!
						</Heading>

						<Text mt="8px" maxW="472px" color="#E5E5E5" textStyle={{ base: 'h6', md: 'h2' }}>
							Please wait while we are getting your scores.
						</Text>
						<Box my={4} px={4}>
							<Text color="#fff" fontSize="2xl">{`${formattedMinutes}:${formattedSeconds}`}</Text>
							<Progress borderRadius={'12px'} colorScheme="purple" mt="12px" size="lg" value={percent} />
						</Box>
					</Box>
				}
			/>
			<ModalTemplateV2
				closeOnOverlayClick={false}
				isOpen={showTestWaitingModal}
				onClose={() => {
					setShowTestWaitingModal(false);
				}}
				showConfetti={false}
				hideIconWithConfetti={true}
				waiting={true}
				// autoCloseInSeconds={30}
				extra={
					<Box>
						{/* <Image w={{ base: '260px', md: '348px' }} h={{ base: '226px', md: '302px' }} mx="auto" src="/images/giff/waiting-gif.gif"></Image> */}
						<Heading mx="auto" textAlign="center" as="h4" maxW="472px" color="#E5E5E5">
							Please wait while we start your test!
						</Heading>

						<Text color="#fff" fontSize="2xl">
							{timeFormat}
						</Text>
						<Progress borderRadius={'12px'} colorScheme="purple" mt="12px" size="lg" value={progress} />
					</Box>
				}
			/>
		</>
	);
};

export default KnowYourLevelCard;
